/* eslint-disable */
import React from "react";
import themePropTypes from "../theme-prop-types";

const VerticalGraphItem = ({ top, times, canShow }) => {
  return (
    <>
      {canShow ? (
        <div className='graph-times-web-sdk'>
          {times
            ?.slice(0)
            .reverse()
            .map((time, index) => {
              return (
                <p
                  className='graph-times-item-web-sdk'
                  style={{ marginTop: `${index == 0 ? -10 : top - 4}px` }}
                  key={index}
                >
                  {time}
                </p>
              );
            })}
        </div>
      ) : null}
    </>
  );
};

VerticalGraphItem.propTypes = themePropTypes.graph;
export default VerticalGraphItem;
